import * as angular from 'angular';
import {IController} from "angular";

export class ServiceLinkCtrl implements IController {
  id: string;
  serviceType: any;
  externalId: string;
  priorityId: string;
  showToolTip: boolean

  private readonly displayExternal: any;
  private displayId: any;

  /* @ngInject */
  constructor(private deliveriesConstants, private splitService, private $state) {
    this.displayExternal = splitService.getSiteExternalIdConfig();
  }

  $onInit() {
    this.displayId = !this.externalId ?
      this.id :
      (this.displayExternal ? this.externalId : this.id);
  }

  $onChanges(changes) {
    if ((changes.id && !changes.id.isFirstChange()) ||
      (changes.externalId && !changes.externalId.isFirstChange())) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceLink', {
    bindings: {
      serviceType: '<',
      id: '<',
      externalId: '<?',
      priorityId: '<?',
      showTooltip: '<?'
    },
    template: require('./service-link.html').default,
    controller: ServiceLinkCtrl
  });
